import { Component, OnInit, Pipe, PipeTransform, Input, Output, EventEmitter } from '@angular/core';
import { Observable, delay, pipe, map, filter, Subject, BehaviorSubject } from 'rxjs';
import { AccordionVM } from './accordion.model';
import html2canvas from 'html2canvas';
import jspdf from 'jspdf';

@Component({
  selector: 'app-accordion',
  templateUrl: './accordion.component.html',
  styleUrls: ['./accordion.component.css'],
})

export class AccordionComponent implements OnInit {

  filteredItems = new Observable<AccordionVM[]>();

  @Input()
  items = new Observable<AccordionVM[]>();

  @Input()
  loaderVisable = new BehaviorSubject<boolean>(false);

  @Input()
  enableGlobalSearch = false;

  @Input()
  nextDataAvailable = new BehaviorSubject<boolean>(false);

  @Output()
  searchText = new EventEmitter()

  searchTextLocal = "";
  constructor() {

  }

  ngOnInit(): void {
    this.filteredItems = this.items;
  }

  async scroll(id: string) {
    setTimeout(() => {
      const element = document.getElementById(id);
      element?.scrollIntoView();
    }, 300);
  }

  clear(input: HTMLInputElement) {
    this.searchTextLocal = "";
    if (this.enableGlobalSearch) {
      var radio = document.getElementById("inlineRadio1") as HTMLInputElement;

      if (!radio.checked) {
        radio.checked = true;
        this.searchText.emit("");
      }
      else {
        this.search(input);
      }
    }
    this.filteredItems = this.items;
  }

  async search(_t12: HTMLInputElement) {
    var isChecked = this.enableGlobalSearch ? (document.getElementById("inlineRadio1") as HTMLInputElement).checked : true;
    var value = (_t12.value == undefined || _t12.value == "") ? '' : _t12.value

    if (isChecked) {
      if (value == "") {
        this.filteredItems = this.items;
        if (this.nextDataAvailable.getValue())
          this.searchText.emit(value);
        return;
      }
      this.filteredItems = this.items.pipe(
        map(sellers =>
          sellers
            .filter(seller => seller.title.includes(value) || seller.body.includes(value))
            .map(seller => {
              return {
                body: seller.body,
                id: seller.id,
                title: seller.title
              }
            })
        ));
    }
    else {
      this.searchText.emit(value);
    }

    setTimeout(() => {
      // var htmlEl = <HTMLElement>document.querySelectorAll("#accordionExample")[0];
      // var oldHtml = htmlEl.innerHTML;
      // oldHtml = oldHtml.replaceAll("<mark>", "");
      // oldHtml = oldHtml.replaceAll("</mark>", "");
      // if (value == null || value == undefined|| value=="") {
      //   htmlEl.innerHTML = oldHtml;
      // }
      // else {
      //   let re = new RegExp(value, "g"); // search for all instances
      //   let newText = oldHtml.replace(re, `<mark>${value}</mark>`);
      //   htmlEl.innerHTML = newText;
      // }
    }, 5000);

  }

  public async captureScreen(id: any) {
    var button = document.getElementById(id.replace("divid","b")) as HTMLButtonElement;
    button.style.display = "none";
    var data: any;
    data = document.getElementById(id) as HTMLDialogElement;
    var img = document.getElementById("logo1") as HTMLImageElement;
    var imgg = new Image();
    imgg.src = img.src;

    html2canvas(data).then(canvas => {
      const imgWidth = 208;
      const pageHeight = 295;
      const imgHeight = canvas.height * imgWidth / canvas.width;
      const heightLeft = imgHeight;

      const contentDataURL = canvas.toDataURL('image/png');
      const pdf = new jspdf('p', 'mm', 'a4', true);
      const position = 0;
      pdf.addImage(imgg, 'PNG', (imgWidth / 2) - 15, 0, 30, 15);
      pdf.addImage(contentDataURL, 'PNG', 0, 15, imgWidth, imgHeight);

      pdf.save('sarvadhnya_com.pdf');
      button.style.display = "block";
    });
  }

}
